import { ROOMS_CATEGORY } from '../../checklistCategories';
import { formatDealOptionName } from '../../shared/format';
import type { ApprovalQueueItem } from '../../types';

import type { RoomDealOptionView, RoomRowView } from './types';

export function buildRoomQueueItem(row: RoomRowView): ApprovalQueueItem {
  return {
    categoryId: ROOMS_CATEGORY.id,
    categoryLabel: ROOMS_CATEGORY.label,
    description: row.summary,
    details: [
      ...row.details,
      ...row.capacity.map((entry) => ({ label: `${entry.label} capacity`, value: entry.value })),
      ...row.dealOptions.map((dealOption) => ({
        label: formatDealOptionName(dealOption.dealOptionName),
        value: formatRoomDealOption(dealOption),
      })),
    ],
    id: row.id,
    title: row.name,
  };
}

function formatRoomDealOption(dealOption: RoomDealOptionView) {
  const allocation = `allocation ${dealOption.allocationLabel}`;
  return `${dealOption.occupancy ?? 'Occupancy unknown'} · ${allocation}${dealOption.differs ? ' — differs' : ''}`;
}

export function getRoomSearchText(row: RoomRowView) {
  return [
    row.name,
    row.roomAssetId,
    ...row.details.map((detail) => detail.value),
    ...row.dealOptions.map((dealOption) => dealOption.dealOptionName),
    row.statusLabel,
  ]
    .filter(Boolean)
    .join(' ');
}
